module.exports = __webpack_public_path__ + "f896f4ff8a65841ad2258db25bbd8d2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/trash-blue-hover.png
// module id = 223
// module chunks = 0